import React from "react";
import "../micro/cotizacion/AlertModalQuoter.css";

export const CustomAlertModal = ({
    visible,
    title,
    message,
    icon = "fa fa-info-circle",
    buttonText = "Aceptar",
    onAccept,
    cancelText,      
    onCancel   
}) => {

    if (!visible) return null;

    return (
        <div className="quoter-modal-backdrop">
            <div className="quoter-modal">

                <div className="quoter-modal-icon">
                    <i className={icon}></i>
                </div>

                <h3 className="quoter-modal-title">
                    {title}
                </h3>

                <p className="quoter-modal-text" dangerouslySetInnerHTML={{ __html: message }} />

                <div className={`quoter-modal-actions ${cancelText ? "two-buttons" : "one-button"}`}>
                    {cancelText ? (
                        <>
                            <button
                                className="quoter-btn-cancel"
                                onClick={onCancel}
                            >
                                {cancelText}
                            </button>

                            <button
                                className="quoter-btn-confirm"
                                onClick={onAccept}
                            >
                                {buttonText}
                            </button>
                        </>
                    ) : (
                        <button
                            className="quoter-btn-confirm"
                            onClick={onAccept}
                        >
                            {buttonText}
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
};